// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
export const PortingDataService = {
    BatchCreate(fn, req) {
        return fn(`/phone/porting/porting-data/v1/create`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    Update(fn, req) {
        try {
            fm.validateUrlParam(req["portingDataId"], "portingDataId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/${req["portingDataId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeletePortingData(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    ByLocationID(fn, req) {
        return fn(`/phone/porting/porting-data/v1/locations/list-port-orders?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CancelPortInOrder(fn, req) {
        try {
            fm.validateUrlParam(req["portingDataId"], "portingDataId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/portin/${req["portingDataId"]}/cancel`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteRequest(fn, req) {
        try {
            fm.validateUrlParam(req["portingRequestId"], "portingRequestId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/porting_request/${req["portingRequestId"]}?${fm.renderURLSearchParams(req, ["portingRequestId"])}`, { method: "DELETE" });
    },
    ProcessPortingRequestsByPhoneNumber(fn, req) {
        return fn(`/phone/porting/porting-data/v1/process-porting-requests`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    PortInCreateByPortingDataID(fn, req) {
        try {
            fm.validateUrlParam(req["portingDataId"], "portingDataId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/portin/${req["portingDataId"]}/create`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    PortInStatusByPortingDataID(fn, req) {
        try {
            fm.validateUrlParam(req["portingDataId"], "portingDataId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/portin/${req["portingDataId"]}/status?${fm.renderURLSearchParams(req, ["portingDataId"])}`, { method: "GET" });
    },
    PortInSUP(fn, req) {
        try {
            fm.validateUrlParam(req["portingDataId"], "portingDataId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/portin/${req["portingDataId"]}/sup`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    PortabilityCheck(fn, req) {
        return fn(`/phone/porting/porting-data/v1/check-portability`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * endpoint for validating portability
     */
    ValidatePortability(fn, req) {
        return fn(`/phone/porting/porting-data/v1/validate-portability`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * PortabilityCheckSF is an endpoint for Salesforce to hit to validate the portability of a phone number.
     * It is required for Salesforce to send an shared password (token), effective date, slug or a location id, and new quota
     * amount. Due to the difference in auth of this endpoint and the shared token to verify that Salesforce is the
     * caller, this endpoint will be limited to HTTP calls with that defined token.
     */
    PortabilityCheckSF(fn, req) {
        return fn(`/phone/porting/porting-data/v1/check-portability-sf`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * SMSHotabilityCheck is an endpoint to validate the sms hotability of a phone number.
     */
    SMSHostabilityCheck(fn, req) {
        return fn(`/phone/porting/porting-data/v1/check-sms-hostability`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetAvailableFOCDates(fn, req) {
        try {
            fm.validateUrlParam(req["portingDataId"], "portingDataId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/portin/${req["portingDataId"]}/foc-dates?${fm.renderURLSearchParams(req, ["portingDataId"])}`, { method: "GET" });
    },
    PortInSMSCreateByPortingDataID(fn, req) {
        try {
            fm.validateUrlParam(req["portingDataId"], "portingDataId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/smshosting/${req["portingDataId"]}`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    CreateSFPortOrderByBatchId(fn, req) {
        try {
            fm.validateUrlParam(req["batchId"], "batchId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/portin/${req["batchId"]}/salesforce/create`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UploadPortOrderDocument(fn, req) {
        return fn(`/phone/porting/porting-data/v1/upload-document`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    DeletePortOrderDocument(fn, req) {
        try {
            fm.validateUrlParam(req["portingDataId"], "portingDataId");
            fm.validateUrlParam(req["mediaDataId"], "mediaDataId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/delete/port-order/${req["portingDataId"]}/media/${req["mediaDataId"]}?${fm.renderURLSearchParams(req, ["portingDataId", "mediaDataId"])}`, { method: "DELETE" });
    },
    UpdatePortOrderDocument(fn, req) {
        return fn(`/phone/porting/porting-data/v1/port-order/document`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ClonePortingData(fn, req) {
        try {
            fm.validateUrlParam(req["portingDataId"], "portingDataId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/${req["portingDataId"]}/clone`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetPortingValidationsByPortingDataID(fn, req) {
        try {
            fm.validateUrlParam(req["portingDataId"], "portingDataId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/portin/${req["portingDataId"]}/porting-validations?${fm.renderURLSearchParams(req, ["portingDataId"])}`, { method: "GET" });
    },
    GetPortOrderUrl(fn, req) {
        try {
            fm.validateUrlParam(req["portingDataId"], "portingDataId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/portin/${req["portingDataId"]}/port-order-url?${fm.renderURLSearchParams(req, ["portingDataId"])}`, { method: "GET" });
    },
    ReadPortingDataByID(fn, req) {
        try {
            fm.validateUrlParam(req["portingDataId"], "portingDataId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/${req["portingDataId"]}?${fm.renderURLSearchParams(req, ["portingDataId"])}`, { method: "GET" });
    },
    GetPortStatusByLocationIDs(fn, req) {
        return fn(`/phone/porting/porting-data/v1/locations/port-statuses?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetPortingAuditHistory(fn, req) {
        try {
            fm.validateUrlParam(req["portingDataId"], "portingDataId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/porting-audit-history/${req["portingDataId"]}?${fm.renderURLSearchParams(req, ["portingDataId"])}`, { method: "GET" });
    },
    /**
     * GetPortingAuditSummary provide a summary for the updates happened with a port order and returns a short summary about the fields changed, timing of the update and by which user
     */
    GetPortingAuditSummary(fn, req) {
        try {
            fm.validateUrlParam(req["portingDataId"], "portingDataId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/porting-audit-summary/${req["portingDataId"]}?${fm.renderURLSearchParams(req, ["portingDataId"])}`, { method: "GET" });
    },
    /**
     * GetPortingAuditRevisionDetails accepts a revision id (unique id for audit log entry ) and returns the details of that particular revision along with details of revision which is present in the DB just before the revision requested in API
     */
    GetPortingAuditRevisionDetails(fn, req) {
        try {
            fm.validateUrlParam(req["portingDataId"], "portingDataId");
            fm.validateUrlParam(req["revisionId"], "revisionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/porting/porting-data/v1/porting-audit-revision/${req["portingDataId"]}/${req["revisionId"]}?${fm.renderURLSearchParams(req, ["portingDataId", "revisionId"])}`, { method: "GET" });
    },
};
